import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "camera-statistics" }
const _hoisted_2 = { class: "camera-statistics__item label-s" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__expand" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.items.total.count) + " " + _toDisplayString(_ctx.$t(`common.in_total`)), 1),
    _createVNode(_component_NButton, {
      type: "link",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setItem(_ctx.items.withProblem)))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.items.withProblem.count) + " " + _toDisplayString(_ctx.$t(`common.with_problem`)), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_NButton, {
      type: "link",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setItem(_ctx.items.doesntWork)))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.items.doesntWork.count) + " " + _toDisplayString(_ctx.$t(`common.doesnt_work`)), 1)
      ]),
      _: 1
    }),
    _hoisted_3
  ]))
}